import { Shield } from "lucide-react";

export const Mission = () => (
  <section className="py-16 md:py-20 bg-white" data-testid="mission-section">
    <div className="container-custom">
      <div className="max-w-4xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 bg-[#0F5132]/10 text-[#0F5132] px-4 py-2 rounded-full text-sm font-semibold mb-6">
          <Shield className="w-4 h-4" />
          Our Mission
        </div>
        <p className="text-2xl md:text-3xl font-medium text-[#1F2937] leading-relaxed mb-6" style={{ fontFamily: "Manrope" }}>
          &quot;We provide an ethical way to recoup costs on surplus supplies while making diabetic care more affordable for the local community.&quot;
        </p>
        <p className="text-lg text-[#4B5563] leading-relaxed max-w-3xl mx-auto" data-testid="mission-buyer-line">
          We buy diabetic supplies in Jacksonville — test strips, CGMs, insulin pumps, and more.
        </p>
      </div>
    </div>
  </section>
);
